import { AIFormat, GithubFormat, SandpackFormat, FileList } from "./formatCode";

export const singleFile: GithubFormat = [
  {
    path: 'index.html',
    content:
    `<!DOCTYPE html>
      <html lang="en">
        <head>
          <meta charset="UTF-8" />
          <meta name="viewport" content="width=device-width, initial-scale=1.0" />
          <title>Game</title>
          <style>
            * {
              margin: 0;
              padding: 0;
            }
      
            body {
              background: #000000;
              color: #fff;
              display: flex;
              justify-content: center;
              align-items: center;
              height: 100svh;
              overflow: hidden;
            }
          </style>
        </head>
        <body>
          <script type="module">
            // Your game logic here
          </script>
          <div></div>
        </body>
      </html>`
  }
];

const more = 
`<!DOCTYPE html>
  <html lang="en">
    <head>
      <meta charset="UTF-8" />
      <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      <title>Game</title>
      <style>
        * {
          margin: 0;
          padding: 0;
          box-sizing: border-box;
        }

        body {
          background: #000000;
          color: #fff;
          height: 100svh;
          overflow: hidden;
        }

        .game-container {
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
        }

        .ui-top {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 60px;
          padding: 5px;
        }

        .ui-bottom {
          position: absolute;
          bottom: 0;
          left: 0;
          width: 100%;
          height: 60px;
          padding: 5px;
        }
      </style>
    </head>
    <body>
      <div class="game-container">
        <div class="ui-top"></div>
        <div class="ui-bottom"></div>
      </div>

      <script type="module">
        // Your game logic here
      </script>
    </body>
  </html>`
;

export const singleFilesForAIList: FileList = [
  'index.html',  
];

export const multiFile: GithubFormat = [
  {
    path: 'public/index.html',
    content:
    `<!DOCTYPE html>
<html lang="en">
  <head>
    <meta charset="utf-8" />
    <meta
      name="viewport"
      content="width=device-width, initial-scale=1, shrink-to-fit=no"
    />
    <meta name="theme-color" content="#000000" />
    <title>Game</title>
    <link rel="preconnect" href="https://fonts.googleapis.com" />
    <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin />
    <link
      href="https://fonts.googleapis.com/css2?family=Lexend:wght@100..900&display=swap"
      rel="stylesheet"
    />
  </head>
  <body>
    <div id="root"></div>
  </body>
</html>`
  },
  {
    path: 'src/styles.css',
    content:
    `html,
body,
.App,
#root {
  background-color: #000;
  color: #fff;
  font-family: "Lexend", sans-serif;
  font-weight: 300;
  font-size: 18px;
  text-align: center;
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}`
  },
  {
    path: 'src/index.tsx',
    content:
    `import React from "react";
import ReactDOM from "react-dom/client";
import App from "../src/App";
import "../src/styles.css";

const rootElement = document.getElementById("root")!;
const root = ReactDOM.createRoot(rootElement);

root.render(
  // <React.StrictMode>
    <App />
  // </React.StrictMode>
);`
  },
  {
    path: 'src/App.tsx',
    content:
    `import Game from "../src/Game";

export default function App() {
  return <Game />;
}`
  },
  {
    path: 'src/Game.tsx',
    content:
    `import React, { useEffect, useRef, useState } from "react";
import * as Phaser from "phaser";
import { GameScene } from "./game/GameScene";
import UIOverlay from "./ui/UIOverlay";
import { VISUAL_SETTINGS } from "./config/VisualSettings";
import { eventBus } from "./ui/EventBus";

const Game: React.FC = () => {
    const rootRef = useRef<HTMLDivElement>(null);
    const phaserGameRef = useRef<Phaser.Game | null>(null);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        if (rootRef.current === null || phaserGameRef.current !== null) return;

        // Do not change the phaser init and responsive scaling, to ensure the game loads and resizes properly
        const config: Phaser.Types.Core.GameConfig = {
            type: Phaser.AUTO,
            width: window.innerWidth,
            height: window.innerHeight,
            parent: rootRef.current,
            scene: [GameScene],
            scale: {
                mode: Phaser.Scale.RESIZE,
                autoCenter: Phaser.Scale.CENTER_BOTH,
            },
            backgroundColor: "#000000",
            // ... additional configuration ...
            // physics: {
            //     default: 'arcade',
            //     arcade: {
            //         gravity: { x: 0, y: 0 },
            //         debug: VISUAL_SETTINGS.DEBUG_HITBOXES
            //     }
            // }
        };

        phaserGameRef.current = new Phaser.Game(config);

        phaserGameRef.current.events.on("ready", () => {
            setIsLoading(false);
            eventBus.emit('phaser:ready', undefined);
        });

        const handleResize = () => {
            if (phaserGameRef.current !== null) {
                phaserGameRef.current.scale.resize(window.innerWidth, window.innerHeight);
            }
            eventBus.emit('phaser:resize', { width: window.innerWidth, height: window.innerHeight });
        };

        window.addEventListener("resize", handleResize);

        return () => {
            if (phaserGameRef.current !== null) {
                phaserGameRef.current.destroy(true);
                phaserGameRef.current = null;
            }
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    return (
        <div
            style={{
                width: "100%",
                height: "100%",
                position: "relative",
                backgroundColor: "#000",
            }}
        >
            <UIOverlay />
            <div
                ref={rootRef}
                style={{
                    width: "100%",
                    height: "100%",
                    margin: 0,
                    padding: 0,
                    backgroundColor: "#000",
                    overflow: "hidden",
                    touchAction: "none",
                    visibility: isLoading ? "hidden" : "visible",
                }}
            />
        </div>
    );
};

export default Game;`
  },
  {
    path: 'src/ui/UIOverlay.tsx',
    content:
    `import React from "react";
import { eventBus } from "./EventBus";

const UIOverlay: React.FC = () => {
    return (
        <div
            style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                display: "flex",
                justifyContent: "space-between",
                padding: "10px",
                boxSizing: "border-box",
                gap: "10px",
            }}
        >
            {/* Top Left */}
            <div>
                {/** Example: emit a template ping from UI */}
                {/**
                <button onClick={() => eventBus.emit('template:ping', { at: Date.now() })}>
                    Send Ping
                </button>
                */}
            </div>

            {/* Top Center */}
            <div />

            {/* Top Right */}
            <div />
        </div>
    );
};

export default UIOverlay;`
  },
  {
    path: 'src/ui/EventBus.ts',
    content:
    `import { useEffect } from "react";
export type CoreEvents = {
    'phaser:ready': void;
    'phaser:resize': { width: number; height: number };
    'template:ping': { at: number };
    'template:pong': { at: number };
};

type Handler<T> = (payload: T) => void;

class TypedEventBus<E extends Record<string, unknown>> {
    private listeners: Map<keyof E, Set<Function>> = new Map();

    on<K extends keyof E>(event: K, cb: Handler<E[K]>): () => void {
        const set = this.listeners.get(event) ?? new Set<Function>();
        set.add(cb as Handler<unknown>);
        this.listeners.set(event, set);
        return () => this.off(event, cb);
    }

    off<K extends keyof E>(event: K, cb: Handler<E[K]>): void {
        const set = this.listeners.get(event);
        if (!set) return;
        set.delete(cb as Handler<unknown>);
        if (set.size === 0) this.listeners.delete(event);
    }

    emit<K extends keyof E>(event: K, payload: E[K]): void {
        const set = this.listeners.get(event);
        if (!set) return;
        set.forEach((fn) => {
            (fn as Handler<E[K]>)(payload);
        });
    }
}

export const eventBus = new TypedEventBus<CoreEvents>();

export function useEventBus() {
    return eventBus;
}

export function useEvent<K extends keyof CoreEvents>(
    event: K,
    handler: (payload: CoreEvents[K]) => void
): void {
    const bus = useEventBus();
    useEffect(() => {
        const off = bus.on(event, handler);
        return () => off();
    }, [bus, event, handler]);
}`
  },
  {
    path: 'src/game/GameScene.ts',
    content:
    `import * as Phaser from 'phaser';
import { BALANCE_SETTINGS } from '../config/BalanceSettings';
import { VISUAL_SETTINGS } from '../config/VisualSettings';
import { eventBus } from '../ui/EventBus';
export class GameScene extends Phaser.Scene {
    // TODO: Main scene goes here

    // Example: ping/pong with UI
    // private unsubscribePing?: () => void;

    // create() {
    //     this.unsubscribePing = eventBus.on('template:ping', ({ at }) => {
    //         eventBus.emit('template:pong', { at });
    //     });
    //     this.events.once(Phaser.Scenes.Events.SHUTDOWN, () => {
    //         if (this.unsubscribePing) this.unsubscribePing();
    //     });
    // }
}`
  },
  {
    path: 'src/config/BalanceSettings.ts',
    content:
    `// Do not rename or remove this file or comment.
// Game balance settings go here, so the user can easily tweak the variables within the game settings panel.
// Avoid using nested objects or arrays; all settings must be at the same level within the BALANCE_SETTINGS object. Prefer SNAKE_CASE for names.
export const BALANCE_SETTINGS = {

};`
  },
  {
    path: 'src/config/VisualSettings.ts',
    content:
    `// Do not rename or remove this file or comment.
// Visual settings go here, so the user can easily tweak the values within the game settings panel. Prefer SNAKE_CASE for names.
// Avoid using nested objects or arrays; all settings must be at the same level within the VISUAL_SETTINGS object.
export const VISUAL_SETTINGS = {
    // DEBUG_HITBOXES: false // Make sure to hook this up to the game physics (or remove it if there is no physics in this game)
};`
  },
];

export const multiFilesForAIList: FileList = [
  'public/index.html',
  'src/styles.css',
  'src/index.tsx',
  'src/App.tsx',
  'src/Game.tsx',
  'src/ui/UIOverlay.tsx',
  'src/ui/EventBus.ts',
  'src/game/GameScene.ts',
  'src/config/BalanceSettings.ts',
  'src/config/VisualSettings.ts',
];


// bundlerURL: 'https://sandpack-bundler.pages.dev',